import { apiUrl } from '../settings/settings';

export const fetchManager = async (method, url, body = undefined) => {
  const response = await fetch(`${apiUrl}${url}`, {
    method,
    headers: customHeader(),
    body: customBody(body),
    mode: 'cors'
  });

  if (response.ok) {
    switch (response.headers.get('Content-Type')) {
      case 'application/vnd.ms-excel':
        return await response.blob();

      default:
        return await response.json();
    }
  }

  throw await response.json();
};

const customHeader = () =>
  new Headers({
    Accept: 'application/json',
    Authentication: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
    'x-api-key': 'SfCN4KQD3rhdU3zDdM9VKpNe',
    'origin': ''
  });

const customBody = body => (body ? JSON.stringify(body) : undefined);
